export default "__VITE_ASSET__Cra6MrOB__"